module.exports = __webpack_public_path__ + "static/media/photo.bd953991.jpg";